<h4 translate="tariff.selectionCard.priceDetailsTitle" data-force-focus="back"></h4>

@for (item of selectedTariff()?.priceIndication?.preisbestandteile?.produktAttribute; track item.name) {
  <mwe-tariff-selection-card-collapse-item [item]="item" (collapseToggleClicked)="onCollapseToggleClicked()" />
}
